<template>
  <sui-page>
    <sui-page-header title="Button UI"/>
    <sui-page-contents>
      <sui-showcase-box title="텍스트 버튼"   :raw-file="sourceB1" collapsible><sample-b1/></sui-showcase-box>
      <sui-showcase-box title="검색영역 버튼" :raw-file="sourceB2" collapsible><sample-b2/></sui-showcase-box>
      <sui-showcase-box title="그리드 버튼"   :raw-file="sourceB3" collapsible><sample-b3/></sui-showcase-box>
      <sui-showcase-box title="섹션기본 버튼" :raw-file="sourceB4" collapsible><sample-b4/></sui-showcase-box>
      <sui-showcase-box title="페이지 버튼"   :raw-file="sourceB5" collapsible>
        <p slot="desc">페이지 최하단 오른쪽에 배치</p>
        <sample-b5/>
      </sui-showcase-box>
      <sui-showcase-box title="페이지 버튼"   :raw-file="sourceB6" collapsible>
        <p slot="desc">페이지 최하단, 양쪽에 버튼 배치 시</p>
        <sample-b6/>
      </sui-showcase-box>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import sampleB1 from             "./sample/comp_button_sample_b1";
import sourceB1 from '!raw-loader!./sample/comp_button_sample_b1';
import sampleB2 from             "./sample/comp_button_sample_b2";
import sourceB2 from '!raw-loader!./sample/comp_button_sample_b2';
import sampleB3 from             "./sample/comp_button_sample_b3";
import sourceB3 from '!raw-loader!./sample/comp_button_sample_b3';
import sampleB4 from             "./sample/comp_button_sample_b4";
import sourceB4 from '!raw-loader!./sample/comp_button_sample_b4';
import sampleB5 from             "./sample/comp_button_sample_b5";
import sourceB5 from '!raw-loader!./sample/comp_button_sample_b5';
import sampleB6 from             "./sample/comp_button_sample_b6";
import sourceB6 from '!raw-loader!./sample/comp_button_sample_b6';

export default {
  name : "compButtonSample",
  components : {
    sampleB1,
    sampleB2,
    sampleB3,
    sampleB4,
    sampleB5,
    sampleB6
  },
  data() {return {
    sourceB1,
    sourceB2,
    sourceB3,
    sourceB4,
    sourceB5,
    sourceB6
  }}
}

</script>